import { render, staticRenderFns } from "./GroupListAddNew.vue?vue&type=template&id=0358f1e2"
import script from "./GroupListAddNew.vue?vue&type=script&lang=js"
export * from "./GroupListAddNew.vue?vue&type=script&lang=js"
import style0 from "./GroupListAddNew.vue?vue&type=style&index=0&id=0358f1e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports